//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FastQuery from "@/0/components/comForm/comFormIndex/comFormIndexFastQuery";
import FormTable from "@/0/components/comForm/comFormIndex/comIndexFormTable.vue";
import FormQuery from "@/0/components/comForm/comFormIndex/comIndexFormQuery.vue";

import FormOperateList from "@/0/components/comForm/comOperateList/comFormOperateList2.vue";

export default {
  components: {
    "page-header": PageHeader,
    "fast-query": FastQuery,

    "form-query": FormQuery,
    "form-table": FormTable,

    "form-operate-list": FormOperateList,
  },
  props: ["config"],
  data() {
    return {
      thisObj: null,
      $manager: null,

      isFormInit: false,

      NavTabView: null,

      tabPageConfigList: [],
      thisTabPageItem: null,

      headerConfig: {
        Title: "创建表单"
      },

      formItem: null,
      fastQueryConfig: {
        text: "请输入搜索内容",
        QueryValue: ""
      },

      tableConfig: {
        DataConfig: {},
        DataList: []
      },

      queryCondition: {},

      operateListConfig: {
        ButtonList: []
      }
    };
  },

  async created() {
    var that = this;
    that.thisObj = that;
    console.log(that.thisObj, "that.thisObj");
    that.$manager = that.$parent.getManager();
    if (!that.$manager) {
      that.$msg.alert("当前的$Manager对象不能为空.");
      return;
    }

    await that.initForm();
  },
  methods: {
    getSubmitData(){
      return this.$getSubmitData();
    },

    $getSubmitData(){
      var formData = this.$refs.comFormQuery.$getSubmitData();
      return formData;
    },
    
    getTabPageDataConfig(tabPage) {
      console.log("tabPage", tabPage);
      var tableConfig = {
        DataConfig: {},
        DataList: [],

        TabPageId: tabPage.TabPageId,
        TabPage: tabPage,

        loadFormData: async () => {
          if (tableConfig.DataList.length > 0) {
            return;
          }

          var postData = {};
          var url = tabPage.FormDataUrl;
          let { data: result } = await this.$http({
            url: url,
            method: "post",
            data: postData
          });
          console.log("loadFormData", result);
          if (result.state == 1) {
            var formData = result.data;
            var resultTable = formData.QueryResultTable;
            if (resultTable && resultTable.DataSource) {
              var dataSource = resultTable.DataSource;
              dataSource.Rows.forEach(m => {
                tableConfig.DataList.push(m);
              });
            }
          }
        }
      };

      if (!tabPage || !tabPage.FormData) {
        return tableConfig;
      }

      var resultTable = tabPage.FormData.QueryResultTable;
      if (resultTable && resultTable.DataSource) {
        var dataSource = resultTable.DataSource;
        tableConfig.DataList = dataSource.Rows;
      }

      return tableConfig;
    },

    async onTabPageChange(tabPageId, title) {
      console.log("onTabPageChange-name", title);
      console.log("onTabPageChange-tabPageId", tabPageId);
      //console.log("onTabPageChange-tabActiveIndex",this.tabActiveIndex);

      var tabPage = this.tabPageConfigList.find(m => m.TabPageId == tabPageId);
      //console.log("tabPage",tabPage);
      this.thisTabPageItem = tabPage;
      if (!tabPage) return;

      await tabPage.loadFormData();
    },

    onManySearchClick() {
      this.$refs.comFormQuery.Show();
    },

    onQueryClick(queryData) {
      this.$refs.comFormQuery.Hide();
    },

    async initForm(pageIndex, pageSize) {
      this.isFormInit = false;
      this.$msg.showLoading("正在获取详细信息...");

      var postData = {};
      // postData.PageIndex = pageIndex;
      // postData.PageSize = pageSize;

      var result = await this.$manager.getIndexTabForm(postData);

      this.$msg.hideLoading();
      if (result.state == 1) {
        this.isFormInit = true;
        this.formItem = result.data;
        var resultData = result.data;

        this.$msg.succ("加载完成");

        this.headerConfig.Title = resultData.Title;
        this.queryCondition = resultData.QueryCondition;

        console.log("resultData.NavTabView", resultData.NavTabView);
        if (resultData.NavTabView) {
          resultData.NavTabView.TabPageList.forEach(tabPage => {
            var dataConfig = this.getTabPageDataConfig(tabPage);
            this.tabPageConfigList.push(dataConfig);
          });

          this.NavTabView = resultData.NavTabView;
          console.log("this.NavTabView", this.NavTabView);
        }

        var resultTable = resultData.QueryResultTable;
        if (resultTable && resultTable.DataSource) {
          var dataSource = resultTable.DataSource;
          this.tableConfig.DataList = dataSource.Rows;
        }

        setTimeout(() => {
          console.log("this.$refs.comFormOperateList",this.$refs.comFormOperateList);
          this.$refs.comFormOperateList.setData(resultData.OperateList);
        },0);

        return;
      }
      this.$msg.alert(result.msg);
    },

    async getIndexPaged(postData = null) {
      var result = await this.$manager.getIndexTabPaged(postData);
      return result;
    },    

    onDetailClick(dataItem, index) {
      console.log("onDetailClick---dataItem", dataItem);
      if (dataItem.DetailUrl) {
        this.$path.to(dataItem.DetailUrl);
        return;
      }

      var detailUrl = this.$parent.getDetailUrl();
      if (detailUrl) {
        var url = detailUrl + "?openId=" + dataItem.OpenId;
        this.$path.to(url);
        return;
      }
    }
  }
};
